/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/BadgeEarnedDialog',['pixi', 'absolute', 'absolute/stringmanager', 'absolute/assetmap', 'MenuUI/MsftButton', 'lodash',
		'MenuUI/ControlFocusManager', 'util/CustomWordWrapper', 'Managers/ScaleManager',
		'Arkadium/GameEngine/Core/EngineManagers'],
	function (PIXI, Absolute, _s, _a, MsftButton, _, ControlFocusManager,
	          CustomWordWrapper, ScaleManager, EngineManagers) {

		var BadgeEarnedDialog = function (ui, game, options) {
			this.initBadgeEarnedDialog(ui, game, options);
		};

		BadgeEarnedDialog.isFirst = true;

		BadgeEarnedDialog.prototype = Object.create(Absolute.Dialog.prototype);

		BadgeEarnedDialog.prototype.initBadgeEarnedDialog = function (ui, game, options) {

			this.ui = ui;
			this.game = game;
			this.options = options;
			this.options.width = options.width || Absolute.Coords.x(1265);
			this.options.height = options.height || Absolute.Coords.y(757);
			this.options.content = this.initContent();
			this.options.displayCloseButton = false;
			this.options.backgroundAlpha = 0.7;

			this.buttonLetterStyle = {
				font: Absolute.ScreenMetrics.getResScale() * 33 + "px Arial",
				fontFamily: 'segoe',
				fill: '#ffffff',
				align: 'left'
			};
			this.buttonThreeSlice = {
				multistate: true,
				images: {
					'left': _a('buttonThreeSliceBlack.left'),
					'center': _a('buttonThreeSliceBlack.center'),
					'right': _a('buttonThreeSliceBlack.right')
				}
			};

			Absolute.Dialog.call(this, ui, this.options);
			this.options.tween.type = 'tweenIn';

			this.controlFocusManager = new ControlFocusManager();

			this.buildButtons();
			this.handleResize();
		};

		BadgeEarnedDialog.prototype.initContent = function () {
			var iconTexture;
			if (this.options.isDCFirstCompleteDialog) {
				iconTexture = "dailychallenge/coin-flip-solitiare_05.png";
			}
			this.contentContainer = Absolute.UIBuilder.buildLayout(
				this.options.dialog, this, this, this.options.width, this.options.height, iconTexture
			);
			if (typeof this.options.contentInitialized === 'function') {
				this.options.contentInitialized.call(this);
			}
			return this.contentContainer;
		};

		BadgeEarnedDialog.prototype.cleanUp = function () {
			Absolute.SpriteUtils.destroyAllChildren(this);
			this.destroy(true);
		};

		BadgeEarnedDialog.prototype.buildButtons = function () {

			var buttons = [
				{
					'text': this.options.buttonText || _s('buttons.close'),
					'threeSlice': this.buttonThreeSlice,
					'width': 180, 'height': 36,
					'position': {"x": this.options.buttonX || 1050, "y": this.options.buttonY || 650},
					'action': function () {
						this.close();
						this.options.closeHandler();
					}.bind(this)
				}
			];

			this.addButtons(buttons);
		};

		BadgeEarnedDialog.prototype.close = function () {
			Absolute.Dialog.prototype.close.call(this);
			ScaleManager.removeElement(this);
		};

		BadgeEarnedDialog.prototype.tweenIn = function () {
			this.handleResize();
			Absolute.Dialog.prototype.tweenIn.call(this);
		};

		BadgeEarnedDialog.prototype.addButtons = function (buttons) {

			this.buttonContainer = new PIXI.DisplayObjectContainer();

			_.each(buttons, function (button) {

				var options = _.extend(button, {'letterStyle': this.buttonLetterStyle}),
					button;

				options.width = Absolute.Coords.x(options.width);
				options.height = Absolute.Coords.x(options.height);
				button = new MsftButton(options);
				button.x = Absolute.Coords.x(options.position.x);
				button.y = Absolute.Coords.x(options.position.y);

				this.buttonContainer.addChild(button);
				this.controlFocusManager.addControl(button, true);

			}, this);

			this.addChild(this.buttonContainer);
		};

		BadgeEarnedDialog.prototype._createBackground = function () {
			var background = new PIXI.Graphics();

			background.beginFill(0x000000, 1);
			background.drawRect(0, 0, this.options.width, this.options.height);
			background.endFill();
			this.addChildAt(background, 0);
		};

		BadgeEarnedDialog.prototype.setText = function (layoutId, text) {
			var stringElement = Absolute.UIBuilder.findWidget(layoutId, this.contentContainer);
			stringElement.setText(text);
			if (stringElement.style.wordWrap) {
				CustomWordWrapper.doTextCustomWrap(
					stringElement, _s.extractNumbersFromString(stringElement.style.font),
					'', stringElement.style.wordWrapWidth, Absolute.Coords.y(110)
				);
			}
		};

		BadgeEarnedDialog.prototype.handleCommand = function (command) {
			switch (command) {
				case 'Tab':
				case 'Right':
					this.controlFocusManager.focusNextControl(1);
					break;
				case 'ShiftTab':
				case 'Left':
					this.controlFocusManager.focusNextControl(-1);
					break;
				case 'Activate':
					this.controlFocusManager.activateCurrentControl();
					break;
			}
		};

		BadgeEarnedDialog.prototype.onShow = function () {
			Absolute.Dialog.prototype.onShow.call(this);
			this.controlFocusManager.focusNextControl(1);
			this.initForceScaleSprite();
			ScaleManager.addElement(this, {scaleChangeSource: 'Full'});
			this.handleResize();
		};

		BadgeEarnedDialog.prototype.initForceScaleSprite = function () {
			this.forceScaleSprite = PIXI.Sprite.fromFrame("Buttons/SubMenuBack/SubMenuBack-Up.png");
			this.forceOffsetX = Absolute.Coords.x(10);
			this.forceOffsetY = Absolute.Coords.y(10);
			this.forceScaleSprite.width = this.options.width + Absolute.Coords.x(15);
			this.forceScaleSprite.height = this.options.height + Absolute.Coords.y(15);
			this.forceScaleSprite.alpha = 0;
			this.addChild(this.forceScaleSprite);
		};

		BadgeEarnedDialog.prototype.handleResize = function () {
			if (this.parent) this.updateTransform();
			this.initForceScaleSprite();
			var oldScaleX = this.scale.x, oldScaleY = this.scale.y;
			this.scale.set(1, 1);
			var initialWidth = this.width, initialHeight = this.height;
			this.scale.set(oldScaleX, oldScaleY);
			var screenScaleX = Absolute.Coords.x(1920) / ScaleManager.width,
				screenScaleY = Absolute.Coords.y(1080) / ScaleManager.height,
				roomWidth = ScaleManager.width, roomHeight = ScaleManager.height;
			this.width = initialWidth * screenScaleX;
			this.height = initialHeight * screenScaleY;
			var realWidth = this.width / screenScaleX, realHeight = this.height / screenScaleY;
			var widthToShow = initialWidth, heightToShow = initialHeight;
			var tookCare = false;
			if (realWidth > roomWidth) {
				this.width = Absolute.Coords.x(1920);
				var delta = roomWidth / widthToShow;
				this.height = ((initialHeight * screenScaleY) * delta);
				if ((this.height / screenScaleY) > roomHeight) {
					this.height = Absolute.Coords.y(1080);
					var delta = roomHeight / heightToShow;
					this.width = ((initialWidth * screenScaleX) * delta);
				}
				tookCare = true;
			}
			if (!tookCare && (realHeight > roomHeight)) {
				this.height = Absolute.Coords.y(1080);
				var delta = roomHeight / heightToShow;
				this.width = ((initialWidth * screenScaleX) * delta);
				if ((this.width / screenScaleX) > roomWidth) {
					this.width = Absolute.Coords.x(1920);
					var delta = roomWidth / widthToShow;
					this.height = ((initialHeight * screenScaleY) * delta);
				}
			}
			this.x = (Absolute.Coords.x(1920) * .5) - (this.width / 2) + this.forceOffsetX;
			this.y = (Absolute.Coords.y(1080) * .5) - (this.height / 2) + this.forceOffsetY;
		};

		return BadgeEarnedDialog;

	});

